/**
 * Loads the cart's related-product slider from the recommendations endpoint.
 * The cart re-renders with morph; data-skip-subtree-update keeps the loaded slides,
 * and a change to the cart's products (data-products) loads a fresh set.
 */
class CartRecommendations extends HTMLElement {
  static observedAttributes = ['data-products'];

  /** @type {AbortController | undefined} */
  #controller;

  connectedCallback() {
    this.#load();
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  /**
   * @param {string} name
   * @param {string | null} oldValue
   * @param {string | null} newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    // Morph sets attributes one at a time; load once they have all landed
    if (oldValue !== null && oldValue !== newValue) queueMicrotask(() => this.#load());
  }

  async #load() {
    const url = this.dataset.url;
    if (!url) return;

    this.#controller?.abort();
    this.#controller = new AbortController();

    try {
      const response = await fetch(url, { signal: this.#controller.signal });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = html.querySelector(`.cart-recs[data-variant="${this.dataset.variant || 'slider'}"]`);

      this.replaceChildren(...(content ? [document.importNode(content, true)] : []));
    } catch (error) {
      if (error instanceof Error && error.name === 'AbortError') return;
      this.replaceChildren();
    }
  }
}

if (!customElements.get('cart-recommendations')) customElements.define('cart-recommendations', CartRecommendations);
